import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { Heading, Paragraph } from '@digdir/designsystemet-react';

import { Tiltak, TiltakMap } from '../../../../../types/registration/tiltak';
import { camelCasify } from '../../../../../utils/navigation';
import i18n, { Language } from '../../../../../i18n';
import { StyledCard } from '../../../../registrationV2025/pages/valgfriDetaljering/form/components/styledComponents';

import { TiltakCategoryWrapper, TiltakWrapper } from './styledComponents';

interface Props {
  tiltakList: Tiltak[];
}

export const TiltakCard: FC<Props> = ({ tiltakList }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tiltak' });

  if (!tiltakList || tiltakList.length === 0) {
    return null;
  }

  const tiltakMap = tiltakList?.reduce(
    (acc: TiltakMap, tiltak) => ({
      ...acc,
      [tiltak.tiltaksKategori]: [...(acc[tiltak.tiltaksKategori] || []), tiltak]
    }),
    {}
  );

  return (
    <TiltakWrapper>
      {Object.entries(tiltakMap).map(([kategori, tiltakIKategori]) => (
        <TiltakCategoryWrapper key={kategori}>
          <Heading level={3} data-size="xs">
            {t(`categories.${camelCasify(kategori)}`)}
          </Heading>
          {tiltakIKategori.map((tiltak, index) => {
            const { beskrivelseBokmal, beskrivelseNynorsk, navnBokmal, navnNynorsk } = tiltak;
            const curLng = i18n.language as Language;
            const tiltakName = curLng === Language.NN_NO ? navnNynorsk : navnBokmal;
            const tiltakBeskrivelse = curLng === Language.NN_NO ? beskrivelseNynorsk : beskrivelseBokmal;

            return (
              <StyledCard isActive key={tiltak.tiltakId}>
                <Heading level={4} data-size="2xs">
                  {t('keyValue', {
                    key: t('tiltakNo', {
                      count: index + 1
                    }),
                    value: tiltakName
                  })}
                </Heading>
                <Paragraph>{tiltakBeskrivelse}</Paragraph>
              </StyledCard>
            );
          })}
        </TiltakCategoryWrapper>
      ))}
    </TiltakWrapper>
  );
};
